import React, { PureComponent } from 'react';

class ToTop extends PureComponent {
    /* START React own Functions */

    componentDidMount(){
        window.addEventListener("scroll", this.handleScroll);
    }

    /* END React own Functions */

    /* START Handles */

    handleScroll() {
        const footerOffset = (document.getElementById("footer").offsetTop - window.outerHeight) + 15
              , goToTopEl = document.getElementById("goToTop");

        if(window.scrollY >= 15 && window.scrollY < footerOffset){
            goToTopEl.className = "active hidden-md-up";
        }else{
            goToTopEl.className = "hidden-md-up";
        }
    }
    handleClick = () => {
        this.scrollToTop(500);
    }

    scrollToTop = (scrollDuration) => {
        var scrollStep = -window.scrollY / (scrollDuration / 15),
            scrollInterval = setInterval(function(){
            if ( window.scrollY !== 0 ) {
                window.scrollBy( 0, scrollStep );
            }
            else clearInterval(scrollInterval);
        },15);
    }

    /* END Handles */

    render() {
        return (
            <div id="goToTop" className="hidden-md-up" onClick={this.handleClick}><i className="fa fa-arrow-circle-up"></i></div>
        );
    }
}

export default ToTop;
